export const EVENTS = {
  SUCCESS: 'TOAST:SUCCESS',
  ALERT: 'TOAST:ALERT',
};

export const triggerToast = (eventName, { title, text = '', className = '', options = {} }) => {
  if (!Object.values(EVENTS).includes(eventName)) {
    throw new Error(`Invalid toast event name: ${eventName}`);
  }

  document.dispatchEvent(
    new CustomEvent(eventName, { detail: { title, text, className, options } }),
  );
};
